<template>
  <div>
    <img class="back" :src="config.images.slipBackground" />
    <div class="slip-unavailable">
      <img
        class="slip-unavailable__brand-logo"
        :src="config.images.brandLogo"
      />

      <p class="slip-unavailable__title">
        <span class="slip-unavailable__title__headline">boleto</span>
        indisponível.
      </p>
      <p class="slip-unavailable__description">
        {{ config.texts.slipUnavailableDescription }}
      </p>

      <v-btn
        v-if="ticketCrmEnabled"
        class="slip-unavailable__btn"
        @click="$router.push({ name: 'ticketForm' })"
      >
        Abrir nova solicitação
      </v-btn>
    </div>
  </div>
</template>

<script>
import { CONFIG, TICKET_CRM } from '../utils/constants';

export default {
  name: 'slip-unavailable',
  computed: {
    config() {
      return this.$store.getters[CONFIG.GET];
    },
    ticketCrmEnabled() {
      return this.$store.getters[TICKET_CRM.GET_ENABLED];
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/breakpoint';

.back {
  z-index: 999999;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;

  @include breakpoint(mobile) {
    width: auto;
  }
}

.slip-unavailable {
  z-index: 9999999;
  background-color: rgba(255, 255, 255, 0.2);
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  text-align: center;

  &__brand-logo {
    width: 14%;
    margin: 35px 43%;

    @include breakpoint(mobile) {
      width: 40%;
      margin: 35px 30%;
    }
  }

  &__title {
    font-size: 36px;
    text-transform: uppercase;
    margin: 56px 0;

    &__headline {
      color: var(--brand-color);
    }
  }

  &__description {
    font-size: 14px;
    font-weight: 600;
  }

  &__btn {
    background-color: var(--brand-color) !important;
    color: #fff !important;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/SlipUnavailable.vue